namespace $ { $mol_style_attach( "hyoo/sketch/element/icon/icon.view.css",
 "/* [hyoo_sketch_element_icon_icon] {\n\tmargin: 0;\n} */\n\n[hyoo_sketch_element_icon_icon]:hover {\n\ttransform: scale(1.5);\n}\n"
) }